import { WorkerSkillDimensionQualityCategory } from '@scale/genai-data-service-client';
import { QualificationType } from '@scale/shared-types';

export const defaultMandatoryName = 'Mandatory Qualifications';
export const defaultViolationListName = 'Trust & Safety Qualification List';
export const enableRevampFF = 'qual-list-revamp-enabled';
export const defaultWorkerSkillMedal = WorkerSkillDimensionQualityCategory.T1;
export const workerSkillTreeLevels = 5;

export const qualificationTypeDisplayNames: { [k in QualificationType]: string } = {
  [QualificationType.AccessLink]: 'Access Link',
  [QualificationType.AccountVerification]: 'Account Verification',
  [QualificationType.Acknowledgement]: 'Acknowledgement',
  [QualificationType.Codeforces]: 'Codeforces',
  [QualificationType.CompleteProfile]: 'Complete Profile',
  [QualificationType.ContributorAgreement]: 'Contributor Agreement',
  [QualificationType.Course]: 'Course',
  [QualificationType.Training]: 'Completed Onboarding',
  [QualificationType.DolphinExam]: 'Dolphin Exam',
  [QualificationType.HackerRank]: 'HackerRank',
  [QualificationType.InstructionItem]: 'Instruction Item',
  [QualificationType.JoinSlack]: 'Join Slack',
  [QualificationType.JoinCommunity]: 'Join Community',
  [QualificationType.SecureTraining]: 'Secure Training',
  [QualificationType.WFESignin]: 'WFE Signin',
  [QualificationType.WFEStartTasking]: 'WFE Start Tasking',
  [QualificationType.WorkerProperty]: 'Worker Property',
  [QualificationType.WorkerSkill]: 'Worker Skill',
  [QualificationType.WorkerExperience]: 'Worker Experience',
  [QualificationType.Webinar]: 'Webinar',
  [QualificationType.OnboardingSuccessRate]: 'Onboarding Success Rate',
  [QualificationType.Tenure]: 'Tenure',
  [QualificationType.ContributorQualityScore]: 'Contributor Quality Score',
  [QualificationType.IdvCheck]: 'IDV Check',
  [QualificationType.CountryPermitted]: 'Country Permitted',
  [QualificationType.NotTraveling]: 'Not Traveling',
  [QualificationType.GoldCheck]: 'Gold Check',
  [QualificationType.NonMarketplaceStatus]: 'Non-Marketplace Status',
  [QualificationType.Experiment]: 'Experiment',
  [QualificationType.FraudBucket]: 'Fraud Bucket',
  [QualificationType.FraudCheckpoint]: 'Fraud Checkpoint',
  [QualificationType.Tag]: 'Tag',
  [QualificationType.InviteBatch]: 'Invite Batch',
  [QualificationType.LinkedInReachable]: 'LinkedIn Reachable',
  [QualificationType.LinkedInConnections]: 'LinkedIn Connections',
  [QualificationType.Cohort]: 'Cohort',
};

export enum StatsCardType {
  Assigned = 'Assigned',
  Available = 'Available',
  Eligible = 'Eligible',
}

export const statsCardTitles: { [k in StatsCardType]: string } = {
  [StatsCardType.Assigned]: 'This project',
  [StatsCardType.Available]: 'Total available',
  [StatsCardType.Eligible]: 'Total eligible',
};

export const statsCardSubtitles: { [k in StatsCardType]: string } = {
  [StatsCardType.Assigned]: 'qualified on this project',
  [StatsCardType.Available]: 'available for this project',
  [StatsCardType.Eligible]: 'eligible for this project',
};

export const qualifiedCountsDefinitions: Record<StatsCardType, string[]> = {
  [StatsCardType.Assigned]: [
    'This is a subset of Total Available. All filters for Total Available are applied here, plus the following filters:',
    'Only contributors who are assigned to this project are included',
    'For Marketplace contributors: Project must be either their chosen assignment or first direct assignment',
    'For worker team contributors: Project must be one of their primary team assignments',
  ],
  [StatsCardType.Available]: [
    'This is a subset of Total Eligible. All filters for Total Eligible are applied here, plus the following filters:',
    'Only contributors who have been online in the last 2 weeks are included',
    'Disabled contributors are excluded',
    'Contributors in the Marketplace who have a first direct assignment to another project are excluded',
  ],
  [StatsCardType.Eligible]: [
    'Shows count of contributors qualified to work on this project. "Qualified" means qualifying for at least one qualification list in the set.',
    'Contributors in fraud or banned worker teams are excluded',
    'Only contributors who have been online in the last 4 weeks are included',
  ],
};

export const qualifiedCountsTooltips: Record<StatsCardType, string> = {
  [StatsCardType.Assigned]: 'Count of contributors who are qualified and assigned to this project',
  [StatsCardType.Available]:
    'Count of contributors who are qualified and available to work on this project',
  [StatsCardType.Eligible]: 'Count of contributors who are qualified to work on this project',
};
